<template>
    <Page type="gray" :nopadding="true">
        <template v-slot:body>
            <span class="text-900 font-medium mb-4 px-3 justify-content-start text-left
                xl:my-5 lg:my-4 md:my-3
                text-3xl xl:text-6xl lg:text-5xl md:text-4xl
                hidden xl:flex lg:flex md:flex">
                {{ header[this.lang].title }}
            </span>
            <SinglePage />
        </template>
    </Page>
</template>

<script>
import Connect from             '@/assets/js/Connect'
import Helper from              '@/assets/js/Helper'
import SinglePage from          '@/components/personal/wallet/SinglePage.vue'
import Page from                '@/components/sides/Page.vue' 

export default {
    data() {
         return {
            header: {
                en: { title: 'Account' },
                ru: { title: 'Счет' }
            },
        }
    },
    components: {
        Page,
        SinglePage,
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)
    }
}
</script>